import { connect } from 'react-redux'
import {changeTemplate,selectActivities, fetchActivity,fetchFamousRace} from '../actions'
import MyTemplates from '../components/MyTemplates'

const mapStateToProps = (state) => {
    return state.poster;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeTemplate: (value) => {
            dispatch(changeTemplate(value));
            if(value==='singleRouteMap' || value==='complete'){
                dispatch(getFirstSelected());
            }
        }
    }
}

const RxMyTemplates = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyTemplates)

function getFirstSelected() {
    return (dispatch, getState) => {
        let state = getState();
        // do some logic based on state, and then:
        if(state.data.selectedActivities.length>0){
            dispatch(selectActivities([state.data.selectedActivities[0]],[state.data.selectedIndices[0]]));

            if(!isNaN(state.data.selectedActivities[0].id)){
                dispatch(fetchActivity(state.data.selectedActivities[0].id,state.app.token));
            }else{
                dispatch(fetchFamousRace(state.data.selectedActivities[0].id));
            }
            
        }
    }
}

export default RxMyTemplates


// WEBPACK FOOTER //
// ./src/containers/RxMyTemplates.js